/**
 * Service Worker Registration for Videa Notes Uploads
 *
 * Registers the chunk upload service worker and provides utilities
 * for checking its status.
 */

// In dev, SW is pre-built to public/dev-sw.js. In prod, VitePWA builds videa-notes-sw.js
const IS_DEV = import.meta.env?.DEV || window.location.hostname === 'localhost';
const SW_PATH = IS_DEV ? '/dev-sw.js' : '/videa-notes-sw.js';

/**
 * Register the Videa Notes upload service worker
 *
 * @param swPath - Path to the service worker file (defaults to /videa-notes-upload-sw.js)
 * @returns The service worker registration
 */
export async function registerUploadWorker(
  swPath: string = SW_PATH,
): Promise<ServiceWorkerRegistration | null> {
  if (!('serviceWorker' in navigator)) {
    return null;
  }

  try {
    // Check if already registered
    const existing = await navigator.serviceWorker.getRegistration(swPath);
    if (existing) {
      return existing;
    }

    // Register new service worker
    const registration = await navigator.serviceWorker.register(swPath, {
      scope: '/',
    });

    // Wait for the worker to be ready
    await navigator.serviceWorker.ready;

    return registration;
  } catch {
    return null;
  }
}

